import { render, staticRenderFns } from "./CarState.vue?vue&type=template&id=0b2fc1b5&scoped=true&"
import script from "./CarState.vue?vue&type=script&lang=js&"
export * from "./CarState.vue?vue&type=script&lang=js&"
import style0 from "./CarState.vue?vue&type=style&index=0&id=0b2fc1b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2fc1b5",
  null
  
)

export default component.exports